module.exports = __webpack_public_path__ + "static/img/file_sass.c5ab1992.png";